import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROJECT_STATUS } from 'gql/projects';

/**
 * Check with the project status, if is withdrawal, terminated or completed, then it is frozen
 * @param {string} projectId
 * @returns {boolean} is frozen?
 */
const useProjectFrozen = (projectId) => {
  const { data, loading } = useQuery(GET_PROJECT_STATUS, {
    variables: { ids: [projectId] },
  });
  const [result, setResult] = useState(true);

  useEffect(() => {
    !loading
      ? setResult(
          data?.projects?.nodes[0]?.projectStatus?.controlType ===
            'WITHDRAWN' ||
            data?.projects?.nodes[0]?.projectStatus?.controlType ===
              'TERMINATED' ||
            data?.projects?.nodes[0]?.projectStatus?.controlType === 'COMPLETED'
        )
      : setResult(true);
  }, [loading, data]);

  return result;
};

export default useProjectFrozen;
